import PropertyFormat, {
    RemoveUnderscoreWithUppercase,
    amountFormat,
} from '../../../../components/commonLayouts/PropertyFormat/PropertyFormat';
import ProductPriceBreakdownLink from '../../../../components/dealFinancing/ProductPriceBreakdown/ProductPriceBreakdownLink';

const getProductRowKey = (product) =>
    product.product_ulid || `${product?.product_name}-${product?.total_price}`;

const getChargeRowKey = (charge) =>
    [charge.charge_type, charge.other_charge_name, charge.product_ulid, charge.charge_amount].join('|');

const getFeeRowKey = (fee) => [fee.fee_type, fee.other_fee_name, fee.fee_amount].join('|');

const getProductDisplayName = (product) => (product?.product_name === '' ? 'Product' : product?.product_name);

const DeaValueCalUI = (props) => {
    const formatCurrency = (value) => amountFormat(value);
    const formatLabel = (text) => text?.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
    return (
        <div className='col-12 col-lg-10 my-3 p-0'>
            <div className='bg-secondary-100 radius8 p-3'>
                <div className='row'>
                    {/* Estimated Deal Value */}
                    <div className='col-8 text-start d-flex align-items-center gap-2'>
                        <p className='text-neutral-900 font-b3 mb-0 text-nowrap'>Estimated Deal Value</p>
                        {props?.props?.role === 'supplier' && (
                            <ProductPriceBreakdownLink dealData={props?.props?.dealData} />
                        )}
                    </div>
                    <div className='col-4 text-end'>
                        <p className='mb-0 text-neutral-900 font-b2 font-semiBold'>
                            {formatCurrency(props?.props?.dealData?.total_deal_value)}
                        </p>
                    </div>
                    <hr />

                    {/* Price Breakdown */}
                    <div className='col-12 text-start'>
                        <p
                            className='mb-1 font-b2'
                            data-bs-toggle='collapse'
                            href='#collapsePrice'
                            role='button'
                            aria-expanded='true'
                            aria-controls='collapsePrice'>
                            Price Breakdown <span className='sf-caret-down'></span>
                        </p>

                        <div className='row m-0 collapse show' id='collapsePrice'>
                            <div className='col-12'>
                                {/* Products */}
                                {props?.props?.dealData?.products?.map((product) => (
                                    <div key={getProductRowKey(product)}>
                                        <p className='mb-0 font-b4 d-flex justify-content-between align-items-start gap-2'>
                                            <span className='text-wrap'>{getProductDisplayName(product)}</span>
                                            <span className='text-nowrap'>
                                                {PropertyFormat(product?.total_price, amountFormat)}
                                            </span>
                                        </p>

                                        <p className='mb-0 font-b4 d-flex justify-content-between align-items-start gap-2'>
                                            <span className='text-wrap'>
                                                {getProductDisplayName(product)}{' '}
                                                &nbsp;{' '}
                                                {props?.props?.role === 'buyer' || props?.props?.role === 'broker'
                                                    ? '@ Extended Credit'
                                                    : '@ Trade Support'}{' '}
                                                {(props?.props?.role === 'buyer' || props?.props?.role === 'broker') &&
                                                    props?.props?.formikProps?.values?.extended_credit_option &&
                                                    PropertyFormat(
                                                        props?.props?.formikProps?.values?.extended_credit_option,
                                                        RemoveUnderscoreWithUppercase
                                                    )}
                                                {props?.props?.role === 'supplier' &&
                                                    props?.props?.formikProps?.values?.early_payment_options &&
                                                    PropertyFormat(
                                                        props?.props?.formikProps?.values?.early_payment_options,
                                                        RemoveUnderscoreWithUppercase
                                                    )}
                                            </span>
                                            <span className='text-nowrap'>
                                                {(() => {
                                                    const isSupplier = props?.props?.role === 'supplier';
                                                    const adjustmentAmount = isSupplier
                                                        ? product?.total_price_early_payment
                                                        : product?.total_price_extended_credit;
                                                    const sign = isSupplier ? '-' : '+';
                                                    return (
                                                        <>
                                                            {sign}
                                                            {amountFormat(Math.abs(adjustmentAmount || 0))}
                                                        </>
                                                    );
                                                })()}
                                            </span>
                                        </p>
                                    </div>
                                ))}

                                {props?.props?.dealData?.additional_charges?.map((charge) =>
                                    charge.charge_type !== '' ? (
                                        <p className='mb-0 font-b4 d-flex justify-content-between align-items-start gap-2' key={getChargeRowKey(charge)}>
                                            <span className='text-wrap'>
                                                {charge.other_charge_name
                                                    ? `${formatLabel(charge.charge_type)} (${charge.other_charge_name})`
                                                    : formatLabel(charge.charge_type)}
                                            </span>
                                            <span className='text-nowrap'>
                                                {PropertyFormat(charge.charge_amount, amountFormat)}
                                            </span>
                                        </p>
                                    ) : null
                                )}

                                {/* Additional Termsheet Fees */}
                                {props?.props?.dealData?.additional_termsheet_fees?.map((fee) =>
                                    fee.fee_type !== '' ? (
                                        <p className='mb-0 font-b4 d-flex justify-content-between align-items-start gap-2' key={getFeeRowKey(fee)}>
                                            <span className='text-wrap'>
                                                {fee.other_fee_name
                                                    ? `${formatLabel(fee.fee_type)} (${fee.other_fee_name})`
                                                    : formatLabel(fee.fee_type)}
                                            </span>
                                            <span className='text-nowrap'>
                                                {PropertyFormat(fee.fee_amount, amountFormat)}
                                            </span>
                                        </p>
                                    ) : null
                                )}
                                {props.props.roleType === 'self_managed' ? (
                                    <>
                                        <p className='mb-0 font-b4 d-flex justify-content-between align-items-start gap-2'>
                                            <span className='text-wrap'>Partner Revenue</span>
                                            <span className='text-nowrap'>
                                                {PropertyFormat(
                                                    props?.props?.dealData?.total_partner_revenue,
                                                    amountFormat
                                                )}
                                            </span>
                                        </p>
                                        <p className='mb-0 font-b4 d-flex justify-content-between align-items-start gap-2'>
                                            <span className='text-wrap'>129Knots Revenue</span>
                                            <span className='text-nowrap'>
                                                {PropertyFormat(
                                                    props?.props?.dealData?.total_129Knots_revenue,
                                                    amountFormat
                                                )}
                                            </span>
                                        </p>
                                    </>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default DeaValueCalUI;
